module.exports = __webpack_public_path__ + "img/santander.430127a.png";